// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const BackgroundFillContract = contract({
  name: "BackgroundFill",
  description: "The background *paint* of a frame — a generative shader, image, video, gradient, repeating texture, or solid token rendered as a layer BEHIND the frame's content. Use it as the first child of a `relative` frame; it paints an `absolute inset-0`, `z-0`, `pointer-events-none` layer, so content carrying `relative z-10` sits on top. This is the canonical way to give any container a rich background — never drop a full-bleed `<ThreeScene>` or `<img>` as a free-standing sibling. For a sized, in-flow media element (a hero card, a thumbnail), use ThreeScene / MediaSurface / VideoPlayer directly instead.",
  import: "@gradeui/ui",
  aliases: ["background","fill","frame fill","backdrop","surface fill","background image","background video","background gradient","background shader","texture","paint"],
  composesWith: ["AppShell","Card","Stack","Row","Grid (any relative container)","ThreeScene (shader fill)","MediaSurface"],
  styleDefaults: {"BackgroundFill":"absolute inset-0 h-full w-full"},
  props: {
  "type": {
      schema: z.enum(["none", "solid", "gradient", "image", "video", "shader"]),
      design: "knob",
      description: "which paint to render (required)",
  },
  "color": {
      schema: z.string().optional(),
      design: "content",
      description: "solid fill; a token name (`primary`, `card`, `muted`, `accent`, `secondary`, `destructive`, `background`, `transparent`) or any CSS colour",
  },
  "gradient": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "stops are token names or CSS colours. shape: \"linear\" (default, uses `angle`, default 135°) | \"radial\" (uses `at` — CSS position like \"top\" / \"30% 20%\", default \"center\" — and optional `size` like \"45rem 50rem\", default farthest-corner)",
  },
  "src": {
      schema: z.string().optional(),
      design: "content",
      description: "image or video URL",
  },
  "fit": {
      schema: z.enum(["cover", "contain", "fill", "none"]).optional(),
      design: "knob",
      description: "object-fit for image/video (default \"cover\")",
  },
  "position": {
      schema: z.string().optional(),
      design: "content",
      description: "CSS object/background position (default \"center\")",
  },
  "repeat": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "tile the image (background-repeat) instead of a single <img>",
  },
  "tileSize": {
      schema: z.string().optional(),
      design: "content",
      description: "CSS background-size when repeating (e.g. \"120px\")",
  },
  "preset": {
      schema: z.string().optional(),
      design: "content",
      description: "shader preset id (see ThreeScene)",
  },
  "fragmentShader": {
      schema: z.string().optional(),
      design: "content",
      description: "custom GLSL (takes precedence over preset)",
  },
  "palette": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "shader palette overrides; wrap tokens as `oklch(var(--token))`",
  },
  "postPreset": {
      schema: z.string().optional(),
      design: "content",
      description: "shader post-FX",
  },
  "opacity": {
      schema: z.number().optional(),
      design: "knob",
      description: "layer opacity 0–1",
  },
  "blendMode": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "blend against the frame behind it",
  },
  "radius": {
      schema: z.enum(["none", "sm", "md", "lg", "xl"]).optional(),
      design: "knob",
      description: "match the frame's radius so the paint clips cleanly",
  },
  },
});
